export default __webpack_public_path__ + "4e942c9bbeb877f34414e777897b9bc9.jpg";